// index.js or main file
import React, {useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route, Routes, useLocation, Navigate } from 'react-router-dom';
import Login from './pages/login/login.jsx';
import AdminRedirect from './adminRedirect/admin';
import Admin from './admin/admin';
import Home from './admin/pages/home/home';
import Rules from './admin/pages/rules/rules';
import { Provider } from 'react-redux';
import { store } from './admin/store';
import LoginPage from './admin/pages/login/login';
import ThankYou from './pages/thankyou/thankyou';
import DayFeedback from './pages/thankyou/DayFeedback';
import StreakPage from './pages/streak/StreakPage';
import Leaderboard from './pages/leaderboard/Leaderboard';
import USER from './pages/dddUI/user';
import ThemeUpdate from './admin/pages/themeupdate/themeupdate';
import CanvasReveal from './pages/canvas-reveal/canvas-reveal';
import WaitingRoom from './pages/waiting-room/waiting-room';
import Canvas from './pages/canvas/canvas';

/** Legacy /stageN links (from before stages were removed) now just go straight to the canvas. */
function LegacyStageRedirect() {
  return <Navigate to="/canvas" replace />;
}


function usePageBackground() {
  const location = useLocation();
  useEffect(() => {
    const body = document.body;
    if (!location.pathname.startsWith("/admin")) {
      body.classList.add("common-bg");
    } else {
      body.classList.remove("common-bg");
    }
  }, [location]); 
}


function App() {
  usePageBackground();

   return (
    <Provider store={store}>
      <Routes>
        {/* Admin routes (no DDDUI wrapper) */}
        <Route path="/admin">
          <Route index element={<Admin><Home /></Admin>} />
          <Route path="rules" element={<Admin><Rules /></Admin>} />
          <Route path="themeupdate" element={<Admin><ThemeUpdate /></Admin>} />
          <Route path="superadmin" element={<LoginPage/>} />
        </Route>

        {/* Public routes wrapped with DDDUI */}
        <Route path="*" element={
          <USER>
            <Routes>
              <Route index element={<Login />} />
              <Route path="/login" element={<Login />} />
              {/* Rules page removed — rules now shown via an in-canvas "How to Play" popup. */}
              <Route path="/rules" element={<LegacyStageRedirect />} />
              <Route path="/leaderboard" element={<Leaderboard/>} />
              <Route path="/AdminRedirect" element={<AdminRedirect />} />
              <Route path="/thankyou" element={<ThankYou/>} />
              <Route path="/feedback" element={<DayFeedback/>} />
              <Route path="/streak" element={<StreakPage/>} />
              <Route path="/stage:stageNum" element={<LegacyStageRedirect />} />
              <Route path="/Stage:stageNum" element={<LegacyStageRedirect />} />
              {/* Removed stage mini-games: send any old bookmarked/deep links straight to the puzzle. */}
              <Route path="/wordle" element={<LegacyStageRedirect />} />
              <Route path="/team-anthem" element={<LegacyStageRedirect />} />
              <Route path="/category-rush" element={<LegacyStageRedirect />} />
              <Route path="/super-squad" element={<LegacyStageRedirect />} />
              <Route path="/wild-tales" element={<LegacyStageRedirect />} />
              <Route path="/letter-loot" element={<LegacyStageRedirect />} />
              <Route path="/word-chain" element={<LegacyStageRedirect />} />
              <Route path="/native-places" element={<LegacyStageRedirect />} />
              <Route path="/super-power-squad" element={<LegacyStageRedirect />} />
              <Route path="/comic-strip-chaos" element={<LegacyStageRedirect />} />
              <Route path="/canvas-reveal" element={<CanvasReveal />} />
              {/* Old route name kept working for anyone with it bookmarked. */}
              <Route path="/big-picture" element={<Navigate to="/canvas-reveal" replace />} />
              {/* Jigsaw puzzle replaced by the collaborative coloring canvas; keep old links working. */}
              <Route path="/puzzle" element={<Navigate to="/canvas" replace />} />
              <Route path="/waiting-room" element={<WaitingRoom />} />
              <Route path="/canvas" element={<Canvas />} />
            </Routes>
          </USER>
        } />
      </Routes>
    </Provider>
  );
}

// Benign browser warning when ResizeObserver callbacks affect layout (e.g. canvas resize).
window.addEventListener('error', (event) => {
  const message = String(event?.message ?? '');
  if (
    message.includes('ResizeObserver loop completed with undelivered notifications') ||
    message.includes('ResizeObserver loop limit exceeded')
  ) {
    event.stopImmediatePropagation();
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

// Performance reporting
reportWebVitals();
